import {
  bookingSourceRequestSchema,
  flightBookingSessionSchema,
  flightCheckoutSchema,
  flightGuestFormSchema,
  type BookingSourceRequest,
  type FlightGuestForm,
} from '@cione/contracts'
import type { HttpClient } from './http'
export function createFlightBookingApi(http: HttpClient) {
  const path = (id: string) => `/api/booking-sessions/${encodeURIComponent(id)}`
  const write = (id: string, action: string, body: unknown, method: 'POST' | 'PUT' = 'POST') =>
    http.request({
      method,
      path: `${path(id)}/flight-${action}`,
      body,
      schema: flightCheckoutSchema,
      timeoutMs: 35000,
    })
  return {
    create: (body: BookingSourceRequest) =>
      http.request({
        method: 'POST',
        path: '/api/booking-sessions',
        body: bookingSourceRequestSchema.parse(body),
        schema: flightBookingSessionSchema,
      }),
    view: (id: string, signal?: AbortSignal) =>
      http.request({
        method: 'GET',
        path: `${path(id)}/flight-checkout`,
        schema: flightCheckoutSchema,
        signal,
      }),
    quotes: (id: string, revision: number) =>
      write(id, 'quotes', { expected_session_revision: revision }),
    select: (id: string, revision: number, ref: string) =>
      write(id, 'selection', { expected_session_revision: revision, candidate_ref: ref }, 'PUT'),
    details: (id: string, revision: number, details: FlightGuestForm) =>
      write(
        id,
        'details',
        { expected_session_revision: revision, details: flightGuestFormSchema.parse(details) },
        'PUT',
      ),
    confirm: (id: string, revision: number) =>
      write(id, 'confirmation', { expected_session_revision: revision }),
    order: (id: string, revision: number, confirmation: string) =>
      write(id, 'orders', { expected_session_revision: revision, confirmation_id: confirmation }),
  }
}
